module.exports = __webpack_public_path__ + "static/media/tokobudi.05370fd1.jpg";